export default __webpack_public_path__ + "static/media/about.f72cc216.jpg";